// extracted by mini-css-extract-plugin
module.exports = {"selectCurrencyInput":"selectCurrencyInput__J4gjn","currencyInput":"currencyInput__tutnf","withButton":"withButton__OI2RN","warning":"warning__dAUU5"};